// extracted by mini-css-extract-plugin
export default {"subjectsContainer":"TopSubjects_subjectsContainer__bT+7x","pharmacyContainer":"TopSubjects_pharmacyContainer__KiqkI","pharmacyTopic":"TopSubjects_pharmacyTopic__QKPz0"};